export default __webpack_public_path__ + "static/media/feature2.b53334c9.png";